import {
    Dialog,
    DialogType,
    DialogFooter,
    PrimaryButton,
    Stack,
    Text,
    useTheme,
} from "@fluentui/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { hideDialog } from "../../store/reducers/dialogSlice";

const NotificationDialog = () => {
    const { visible, message, resultList, confirmAction } = useSelector(
        (state: RootState) => state.dialog
    );
    const dispatch = useDispatch();
    const theme = useTheme();

    const handleConfirm = () => {
        localStorage.removeItem("selectedlabinventory");
        window.dispatchEvent(new Event("clearLabSelection"));
        dispatch(hideDialog());
        setTimeout(() => {
            window.location.reload();
        }, 50);
    };

    const handleClose = () => {
        dispatch(hideDialog());
    };

    const isArray = Array.isArray(resultList);

    const backgroundColor = theme.semanticColors.bodyBackground;
    const borderColor = theme.semanticColors.bodyDivider;
    const textColor = theme.semanticColors.bodyText;
    const successColor = theme.palette.green;
    const errorColor = theme.palette.red;

    const isNoRecordFound =
        (typeof message === "string" &&
            (message.toLowerCase().includes("found") ||
                message.toLowerCase().includes("required"))) ||
        (Array.isArray(message) &&
            message.some(
                (msg: string) =>
                    msg.toLowerCase().includes("found") ||
                    msg.toLowerCase().includes("required")
            ));


    return (
        <Dialog
            hidden={!visible}
            dialogContentProps={{
                type: DialogType.normal,
                title: isArray ? "Action Results" : "Information",
                subText: !isArray ? message : undefined,
            }}
            modalProps={{
                isBlocking: true,
                styles: {
                    main: {
                        backgroundColor: backgroundColor,
                        selectors: {
                            ".ms-Dialog-button--close": { display: "none" },
                        },
                    },
                },
            }}
        >
            {isArray && (
                <Stack
                    styles={{
                        root: {
                            backgroundColor: backgroundColor,
                            border: `1px solid ${borderColor}`,
                            borderRadius: 6,
                            padding: "8px 12px",
                            maxHeight: 300,
                            overflowY: "auto",
                        },
                    }}
                    tokens={{ childrenGap: 6 }}
                >
                    {resultList.map((item: any, index: number) => {
                        const isSuccess =
                            (item.message || "").toLowerCase().includes("success");
                        return (
                            <Stack
                                key={index}
                                horizontal
                                horizontalAlign="space-between"
                                verticalAlign="center"
                                styles={{
                                    root: {
                                        borderBottom:
                                            index < resultList.length - 1
                                                ? `1px solid ${borderColor}`
                                                : "none",
                                        padding: "6px 0",
                                        backgroundColor: backgroundColor,
                                    },
                                }}
                            >
                                <Text
                                    variant="smallPlus"
                                    styles={{
                                        root: {
                                            color: isSuccess ? successColor : errorColor,
                                            fontWeight: 600,
                                            textTransform: "capitalize",
                                        },
                                    }}
                                >
                                    {item.message}
                                </Text>
                            </Stack>
                        );
                    })}
                </Stack>
            )}

            <DialogFooter>
                {isNoRecordFound || confirmAction === "CLOSE_ONLY" ? (
                    <PrimaryButton text="OK" onClick={handleClose} />
                ) : (
                    <PrimaryButton text="OK" onClick={handleConfirm} />
                )}
            </DialogFooter>
        </Dialog>
    );
};

export default NotificationDialog;
